import {nPost,nGet} from '../../libs/ajax.js'

export default {
    //  检查计划是否可进行复制
    postCheckPlan:(data,options) => {
        return nPost('/oppo/copy/check_plan', data, options);
    },
    //  添加复制任务
    postSavePlan:(data,options) => {
        return nPost('/oppo/copy/save', data, options);
    },
    //  搜索获取账户列表
    getCompanyList:(data,options) => {
        return nGet('/oppo/copy/get_company_list', data, options);
    },
    //  搜索获取计划列表
    getPlanList:(data,options) => {
        return nGet('/oppo/copy/get_plan_list', data, options);
    },
    //  获取任务列表
    postTaskList:(data,options) => {
        return nPost('/oppo/copy/task/get_list', data, options);
    },
    // 获取任务下拉搜索框列表
    getTaskSearchList:(data,options) => {
        return nGet('/oppo/copy/task/get_search_list', data, options);
    },
    // 获取任务汇总数据
    postTaskTotal:(data,options) => {
        return nPost('/oppo/copy/task/get_total', data, options);
    },
    // 任务复制
    getTaskInfo:(data,options) => {
        return nGet('/oppo/copy/task/get_info', data, options);
    },
    // 获取任务详情列表
    getTaskDetailList:(data,options) => {
        return nGet('/oppo/copy/detail/get_list', data, options);
    },
    // 获取任务详情汇总数据
    getTaskDetailTotal:(data,options) => {
        return nGet('/oppo/copy/detail/get_total', data, options);
    },
    // 更新计划列表
    postUpdatePlan:(data,options) => {
        return nPost('/oppo/copy/update_plan_list', data, options);
    },
    // 任务重试
    postRetryTask:(data,options) => {
        return nPost('/oppo/copy/task_retry', data, options);
    },
}